import DomComponent from 'App/lib/domComponent';
import { debounce2, mq } from 'App/lib/util';
import { duration } from 'App/lib/const';
import SendRequest from "../../lib/ajax";
import { pushTrackingData } from '../../lib/dataLayer';

const searchResultTemplate = require('./search-results.template.pug');

export default class SearchComponent extends DomComponent {
    static selector = '[data-js-search]';
    input;
    results;
    resultsContainer;
    initialHeight;
    searchExpanded = false;
    searchUrl;

    constructor(el, Header) {
        // return false
        super(el);

        this.Header = Header;

        this.input = this.el.querySelector('[data-input]');
        this.form = this.el.querySelector('[data-form]');
        this.results = this.el.querySelector('[data-results]');
        this.quickTip = this.el.querySelector('[data-content]');
        this.resultsContainer = this.el.querySelector('[data-results-container]');
        this.searchUrl = this.el.getAttribute('data-search-results-url');

        // event listeners
        const debouncedFn = debounce2(this.inputHandler.bind(this), 200);

        if (this.input && this.results) {
            this.input.addEventListener('input', (e) => {
                debouncedFn(e);
            });
        }

        this.form.addEventListener('submit', (e) => {
            e.preventDefault();

            if (this.input.value) {
                this.submitHandler(e);
            }
        });

        //set initial height on quick tip
        const height = this.quickTip.firstElementChild.offsetHeight;
        this.quickTip.style.height = `${height}px`;

        this.initialHeight = this.el.parentElement.offsetHeight;

        // set max height on search results so it doesnt spill beneath window
        if (mq(this.Header.desktopMediaQuery)) {
            const styles = getComputedStyle(this.el.parentElement);
            const usedSpace = this.input.offsetHeight +
                parseInt(styles.paddingTop) +
                parseInt(styles.paddingBottom);

            const maxHeight = window.innerHeight - this.Header.el.offsetHeight - usedSpace;
            this.resultsContainer.style.maxHeight = `${maxHeight}px`;
        }

        this.resultsContainer.addEventListener('click', (e) => {
            const { target } = e;

            if (target.matches('.search__result') === false) {
                return;
            }

            pushTrackingData({
                'name': 'nav_search_result',
                'click_text': target.innerText,
                'click_url': target.getAttribute('href')
            });
        });

        setTimeout(() => {
            this.loaded();
        })
    }

    submitHandler() {
        const urlParams = this.input.value ? `?term=${this.input.value}` : '';
        window.location = this.searchUrl + urlParams;
    }

    inputHandler() {
        if (this.input.value) {

            if (!this.searchExpanded) {
                this.searchExpanded = true;
                this.Header.expandSearchMenu();
            }

            this.showLoader();

            this.search(this.input.value).then((data) => {
                let html;

                if (data.results && data.results.length) {
                    html = searchResultTemplate(data);
                } else {
                    html = '<p>No results Found for search term \'' + this.input.value + '\'</p>'
                    this.showQuickTip();
                }

                this.updateResults(html);
                setTimeout(() => {
                    if (!this.resultsContainer.classList.contains('overflow-scroll')) {
                        this.resultsContainer.classList.add('overflow-scroll');
                    }
                }, duration);
                // const results = this.results.querySelectorAll('')
            })
        } else {
            this.clearResults();
            this.showQuickTip();
            this.Header.minimizeSearchMenu(this.initialHeight);
            this.searchExpanded = false;
        }
    }

    updateResults(html) {
        this.results.innerHTML = html;
        this.resultsContainer.style.height = `${this.results.offsetHeight}px`;
    }

    clearResults() {
        this.results.innerHTML = '';
        this.resultsContainer.style.height = '0px';
        this.resultsContainer.classList.remove('overflow-scroll');
        this.showQuickTip();
    }

    hideQuickTip() {
        this.quickTip.style.opacity = 0;
        this.quickTip.style.height = '0px';
        this.quickTip.classList.add('closed');
    }
    showQuickTip() {
        this.quickTip.classList.remove('closed');
        this.quickTip.style.opacity = 1;
        this.quickTip.style.height = `${this.quickTip.firstElementChild.offsetHeight}px`;
    }

    showLoader() {
        this.hideQuickTip();

        if (!this.el.querySelectorAll('.loader').length) {
            this.updateResults('<div class="loader"></div>');
        }
    }

    search(term) {
        let encodedTerm = encodeURIComponent(term),
            url = '/umbraco/rhythm/searchapi/search?term=' + encodedTerm;
        const request = new SendRequest(url);

        return request.then((data) => {
            pushTrackingData({
                'name': 'nav_execute_search',
                'search_query': term,
            });

            return JSON.parse(data.text);
        });
    }
}